// extracted by mini-css-extract-plugin
export default {"projects-wrapper":"TabContainer_projects-wrapper__J4ilV","projects-title-wrapper":"TabContainer_projects-title-wrapper__5wOkz"};